/**
 * MY Register — L_OFFICER.OCCUPATION 저장용 jsonData 해석
 */
export function resolveRegisterOccupationForOfficerSave(
    jsonData: Record<string, unknown>,
): string | undefined {
    const hasOccupationField = (
        jsonData.BUSINESS_OCCUPATION !== undefined
        || jsonData.OCCUPATION !== undefined
        || jsonData.MEMBER_OCCUPATION !== undefined
        || jsonData.Occupation !== undefined
    );
    if (!hasOccupationField) return undefined;

    const occupation = jsonData.BUSINESS_OCCUPATION
        ?? jsonData.OCCUPATION
        ?? jsonData.MEMBER_OCCUPATION
        ?? jsonData.Occupation;

    return String(occupation ?? '').trim();
}

export type MyRegisterOfficerUpdatePayload = {
    appointmentDate?: string | null;
    cessationDate?: string | null;
    occupation?: string;
    designation?: string;
    secretaryLicenseNo?: string;
    secretaryCertificateNo?: string;
    firmNo?: string;
};

/** Director — L_OFFICER.DESIGNATION (Designation of Director's Position & Subrole) */
export function resolveRegisterDesignationForDirectorSave(
    jsonData: Record<string, unknown>,
): string | undefined {
    if (jsonData.DESIGNATION === undefined) return undefined;
    return String(jsonData.DESIGNATION ?? '').trim();
}

export function buildMyRegisterDirectorUpdatePayload(
    jsonData: Record<string, unknown>,
): MyRegisterOfficerUpdatePayload {
    const appointmentDate = String(jsonData.APPOINTMENT_DATE ?? '').trim() || null;
    const cessationDate = String(
        jsonData.CESSATION_DATE ?? jsonData.cessationDate ?? '',
    ).trim() || null;
    const designation = resolveRegisterDesignationForDirectorSave(jsonData);
    const occupation = resolveRegisterOccupationForOfficerSave(jsonData);

    return {
        appointmentDate,
        cessationDate,
        ...(designation !== undefined ? { designation } : {}),
        ...(occupation !== undefined ? { occupation } : {}),
    };
}

export function buildMyRegisterOfficerUpdatePayload(
    jsonData: Record<string, unknown>,
): MyRegisterOfficerUpdatePayload {
    const appointmentDate = String(jsonData.APPOINTMENT_DATE ?? '').trim() || null;
    const cessationDate = String(
        jsonData.CESSATION_DATE ?? jsonData.cessationDate ?? '',
    ).trim() || null;
    const occupation = resolveRegisterOccupationForOfficerSave(jsonData);

    return {
        appointmentDate,
        cessationDate,
        ...(occupation !== undefined ? { occupation } : {}),
    };
}
